var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-common-buttons"},_vm._l((_vm.btns),function(v,i){return _c('div',{directives:[{name:"stat",rawName:"v-stat",value:(v.stat),expression:"v.stat"}],key:i,staticClass:"list-common-buttons-item",on:{"click":v.onClick}},[_vm._v(" "+_vm._s(v.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }